import { IJobListing } from "@/types/job";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface JobSearchFilters {
  term: string;
  location: string;
  remote: boolean;
  page: number;
}

interface JobSearchResults {
  jobs: IJobListing[];
  total: number;
}

interface JobSearchState {
  filters: JobSearchFilters;
  results: JobSearchResults | null;
  isLoading: boolean;
}

const initialState: JobSearchState = {
  filters: {
    term: "",
    location: "",
    remote: false,
    page: 1,
  },
  results: null,
  isLoading: false,
};

const jobSearchSlice = createSlice({
  name: "jobSearch",
  initialState,
  reducers: {
    setSearchFilters: (state, { payload }: PayloadAction<Partial<JobSearchFilters>>) => {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };
    },
    setSearchResults: (state, { payload }: PayloadAction<JobSearchResults>) => {
      return {
        ...state,
        results: payload,
      };
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      return {
        ...state,
        isLoading: payload,
      };
    },
    clearSearch: () => initialState,
  },
});

export const { setSearchFilters, setSearchResults, setLoading, clearSearch } = jobSearchSlice.actions;
export const { reducer: jobSearchReducer } = jobSearchSlice; 